<template>
	<v-dialog
		v-model="dialog"
		scrollable
		persistent
		content-class="launcher-dialog"
		:width="modal_width"
		:max-width="modal_width"
		transition="dialog-transition">
		<v-card class="background darken-1" v-if="step === 'search'">
			<v-card-title>
				<LauncherHeader
					:step="step"
					:jd="jd_version_selected"
					@open-old-launcher="openOldLauncher()"
					@close="$emit('close')"
					@search="step = 'search'">
				</LauncherHeader>
			</v-card-title>
			<v-card-text>
				<JdsMenu
					:jds="jds_filtered"
					:loading="loading_jds"
					:jd_type_selected="jd_type_selected"
					:jd_selected="jd_selected"
					:jd_version_selected="jd_version_selected"
					:versions="jd_versions"
					@change="onJdSelected($event)"
					@version-selected="jd_version_selected = $event">
					<template slot="jd-append">
						<TypesMenu
							:jds_types="jds_types"
							:loading="loading_jds"
							:jd_type_selected="jd_type_selected"
							@change="onTypeSelect($event)">
						</TypesMenu>
						<FrequentJds
							:jds="jds"
							@select-jd="onFrequentJdSelect($event)">
						</FrequentJds>
						<v-btn
							v-if="$user.isAdmin()"
							small icon
							class="mt-2"
							color="background darken-1"
							:to="{name: 'Maestro search'}"
							target="_blank">
							<v-icon>search</v-icon>
						</v-btn>
					</template>
				</JdsMenu>
				<LauncherHistory
					:jds="jds"
					:jd_selected="jd_selected"
					@open-form="onJdSelected($event)">
				</LauncherHistory>
			</v-card-text>
			<v-card-actions>
				<v-btn
					flat
					color="primary"
					class="text-none"
					:disabled="!jd_version_selected"
					@click="downloadTemplate()">
					<v-icon class="mr-1">file_download</v-icon>
					Template XLSX
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					flat
					color="primary"
					class="text-none"
					:disabled="!jd_version_selected"
					@click="step = 'batch'">
					<v-icon class="mr-2" large>playlist_play</v-icon>
					Editer un batch
				</v-btn>
				<v-btn
					color="primary color--text"
					class="text-none"
					:disabled="!jd_version_selected"
					@click="step = 'unitary'">
					<v-icon class="mr-2" large>play_arrow</v-icon>
					Configurer un job
				</v-btn>
			</v-card-actions>
		</v-card>

		<template v-if="step === 'unitary'">
			<LauncherUnitary
				:jd="jd_version_selected"
				:parameters="parameters"
				:param="param"
				:parent_jr_id="parent_jr_id"
				:dialog="dialog"
				@close="$emit('close')"
				@edit-batch="unitary_to_batch_data = $event; step = 'batch'"
				@modal-width="modal_width = $event || '1080px'">
				<template v-slot:card-title>
					<LauncherHeader
						:step="step"
						:jd="jd_version_selected"
						@close="$emit('close')"
						@search="$emit('remove-dupli-data');
											step = 'search';
											modal_width = '1080px'">
					</LauncherHeader>
				</template>
			</LauncherUnitary>
		</template>

		<template v-if="step === 'batch'">
			<LauncherBatch
				:jd="jd_version_selected"
				:jds="jds"
				:last_version_number="jd_versions[0].version_number"
				:unitary_to_batch_data="unitary_to_batch_data"
				@unitary-data-loaded="unitary_to_batch_data = null"
				@change-jd="jd_selected = $event"
				@change-jd-version="jd_version_selected = $event"
				@change-jd-versions="jd_versions = $event"
				@modal-width="modal_width = $event || '1080px'">
				<template v-slot:card-title>
					<LauncherHeader
						:step="step"
						:jd="jd_version_selected"
						@close="$emit('close')"
						@search="step = 'search'; modal_width = '1080px'">
					</LauncherHeader>
				</template>
			</LauncherBatch>
		</template>

	</v-dialog>
</template>

<script>
import BatchJs from '@/pages/maestro/launcher/launcher_xlsx.js'
import { useJdListLight } from '@/composables/jobdescriptor_list_light.js'
import { toRefs } from '@vue/composition-api'
import TypesMenu from '@/pages/maestro/launcher/launcher_types_menu.vue'
import FrequentJds from '@/pages/maestro/launcher/launcher_frequent_jds.vue'
import LauncherHistory from '@/pages/maestro/launcher/launcher_history.vue'
import JdsMenu from '@/pages/maestro/launcher/launcher_jds_menu.vue'
import LauncherUnitary from '@/pages/maestro/launcher/launcher_unitary.vue'
import LauncherBatch from '@/pages/maestro/launcher/launcher_batch.vue'
import LauncherHeader from '@/pages/maestro/launcher/launcher_v2_header.vue'
export default {
	name: 'Launcher_V2',
	props: [ 'dialog', 'jd_id', 'parameters', 'param', 'parent_jr_id', 'direct_edit' ],
	components: {
		TypesMenu,
		FrequentJds,
		LauncherHistory,
		JdsMenu,
		LauncherHeader,
		LauncherUnitary,
		LauncherBatch
	},
	setup (props, { root }) {
		const { param } = toRefs(props)
		let types = root.$commons.deepGet(param, 'value.type', null)
		const jdListLightInfos = useJdListLight(types)
		return {
			jds: jdListLightInfos.jds,
			jds_types: jdListLightInfos.jds_types,
			loading_jds: jdListLightInfos.is_loading,
			getJobdescriptorListLight: jdListLightInfos.getJdListLight
		}
	},
	data () {
		return {
			step: 'search',
			modal_width: '1080px',
			jd_type_selected: null,
			jd_selected: null,
			jd_versions: [],
			unitary_to_batch_data: null,
			loading_versions: false,
			jd_version_selected: null
		}
	},
	computed: {
		jds_filtered () {
			if (this.jd_type_selected === null ||
				this.jd_type_selected === undefined) return this.jds
			return this.jds.filter(jd => {
				return jd.typing === this.jd_type_selected.value
			})
		}
	},
	watch: {
		dialog (val) {
			if (val) this.init()
		},
		jds (val) {
			if (!val) return
			for (let i = 0; i < val.length; i++) {
				if (val[i].id === this.jd_id) {
					this.onJdSelected(val[i])
					break
				}
			}
		}
	},
	methods: {
		onJdSelected (jd) {
			this.jd_selected = jd
			this.jd_versions = []
			if (jd) {
				this.loading_versions = true
				this.$EsMaestro.jobdescriptor_read(jd.id)
					.then(result => {
						this.jd_versions = result
						this.jd_version_selected = result[0]
						if (this.direct_edit) {
							this.step = 'search'
							this.$nextTick(() => {
								this.step = 'unitary'
							}, 1000)
						}
						let routeQuery = JSON.parse(JSON.stringify(this.$route.query))
						routeQuery.launcher_jd = jd.id
						this.$router.replace({
							path: this.$route.path,
							name: this.$route.name,
							params: this.$route.params,
							query: routeQuery
						}).catch(error => {
							console.error(error.message)
						})
					})
					.catch(error => {
						console.error(error)
					})
					.finally(() => {
						this.loading_versions = false
					})
			} else {
				let routeQuery = JSON.parse(JSON.stringify(this.$route.query))
				delete routeQuery.launcher_jd
				this.$router.replace({
					path: this.$route.path,
					name: this.$route.name,
					params: this.$route.params,
					query: routeQuery
				}).catch(error => {
					console.error(error.message)
				})
			}
		},
		openOldLauncher () {
			let msg = { dialog: true, version: 1 }
			if (this.jd_id) msg.jd_id = this.jd_id
			if (this.parameters) msg.parameters = this.parameters
			if (this.param) msg.param = this.param
			if (this.parent_jr_id) msg.parent_jr_id = this.parent_jr_id
			this.$Bus.$emit('launcher', msg)
		},
		downloadTemplate () {
			BatchJs.download_xlsx(
				this.jd_version_selected,
				this.jd_versions[0].version_number
			)
		},
		onTypeSelect (type) {
			this.jd_type_selected = type
			if (type && this.jd_selected) {
				if (this.jd_selected.typing !== type) this.jd_selected = null
			}
		},
		onFrequentJdSelect (jdId) {
			if (jdId) {
				this.jd_type_selected = null
				for (const jd of this.jds) {
					if (jd.id === jdId) {
						this.jd_selected = jd
						this.jd_version_selected = null
						return
					}
				}
			}
			this.jd_selected = null
			this.jd_version_selected = null
		},
		init () {
			let types = this.$commons.deepGet(this.param, 'type', null)
			this.getJobdescriptorListLight(types)
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>.launcher-dialog
	top: 10px
	position: absolute
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_v2.vue